import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function NeedDocumentation() {
  const { searchObject, t, setSearchObject } = useAdvanceSearchContext();

  function oncheckBoxCheked({ target }) {
    setSearchObject({
      ...searchObject,
      [target.name]: target.checked
    });
  }
  
  return (
    <fieldset>
      <legend>{t("Need Documentation?")}</legend>
      <input
        type="checkbox"
        checked={searchObject.needDocumentation}
        name="needDocumentation"
        onChange={oncheckBoxCheked}
        className="form-check-input"
      />
      <label className="form-check-label" style={{marginLeft:"10px"}}>{t("Need Documentation?")}</label>
    </fieldset>
  );
}
